import React, { useState, useContext, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment, CircularProgress } from "@mui/material";
import infoIcon from "../../images/infoIcon.svg";
import "../../styles/components/Editor.scss";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import "../../styles/pages/TemplateManager.scss";
import DropDownWithLabelSizeTemplate from "../../components/DropdownWithLabelSizeTemplate.js";
import TextFieldInputTemp from "../../components/CommonComponents/TextFieldInputTemp";
import DropDownWithLabelTemplate from "../../components/DropDownWithLabelTemplate.js";
import {
  getNewBrandsAndcampaigns,
  cloneBanner,
  getMarketList,
} from "../../services/apis";
import DropDownWithSearchTemplate from "../../components/DropDownWithSearchTemplate";
import { toast } from "react-toastify";
//Denovo related imports
//MArket Data returnlated imports and varaihle declaration
import { nameValidation } from "../../Uitls/Util.js";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@mui/material/Button";
import { templateSizes } from "../../Uitls/RightPanelToolBarItems";

export default function CloneTemplateModal(props) {
  const history = useHistory();
  const {
    setShowCloneTemplate,
    showCloneTemplate,
    recentlyViewedData,
    genericInfoNew,
  } = props;
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    templateNameInput: "",
    templateSize: "",
    Width: 0,
    Height: 0,
    templateType: "",
    campaignId: "",
    templateType: "",
    templateSizeType: "",
    promomatTempDocId: "ES-BVY-0064",
  });
  const [helperText, setHelperText] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const templateSizeOptions = ["Pre-defined", "Custom"];
  const [attributes, setAttributes] = useState({});
  const closeCloneTempModal = (e) => {
    setShowCloneTemplate(false);
    setCloneloader(false);
  };
  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      templateNameInput: "",
      //tagName: "",
      templateSize: "",
      Width: 0,
      Height: 0,
      templateType: "",
      templateSizeType: "",
    });
    setSelectedMarket("");
  };
  const { t } = useTranslation();
  const dropdownWidth = useRef(null);

  React.useEffect(() => {
    fetchBrandsAndCampaigns();
    fetchMarketData();
    getCampaignListToPopulate(
      appData?.genericInfo?.brand || recentlyViewedData?.brand,
    );
  }, []);
  useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: appData?.genericInfo?.campaign,
      brand: appData.genericInfo.brand,
      market: appData.genericInfo.market,
      templateType: appData?.genericInfo?.isAnimated ? "Animated" : "Static",
      templateSizeType: appData?.attributes?.customTemp
        ? "Custom"
        : "Pre-defined",
      templateSize: getTemplateSize(
        appData?.genericInfo?.height,
        appData?.genericInfo?.width,
      ),
      Width: appData?.genericInfo?.width,
      Height: appData?.genericInfo?.height,
    });
    setAttributes(appData?.genericInfo);
  }, []);

  //Fetch Brands and campaigns
  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });
          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(sortedData);
        }
      }
    });
  };

  //Returns Campaign list to populate in Drop down
  const getCampaignListToPopulate = (Brand) => {
    if (Brand && brandsAndCampaigns.length > 0) {
      const campaigns = brandsAndCampaigns.filter((object) => {
        return object.brandName === Brand;
      })[0]?.campaigns;
      if (campaigns && campaigns.length > 0) {
        const desiredList = campaigns.map((campaign) => {
          return campaign["campaignName"];
        });
        if (desiredList && desiredList.length > 0) {
          return desiredList;
        }
      }
    }
    return [];
  };

  function validateForm() {
    return (
      genericInfo.templateNameInput &&
      genericInfo.templateNameInput.trim() !== "" &&
      genericInfo.brand?.length > 0 &&
      genericInfo.market?.length > 0 &&
      genericInfo.templateType?.length > 0 &&
      (genericInfo.templateSize?.length > 0 ||
        (genericInfo.Width > 0 && genericInfo.Height > 0))
    );
  }
  const handleChangeInfoDataBlur = (e) => {
    if (e.target.value.length < 3 && e.target.value.length !== 0) {
      toast.error(
        <div className="notificationText">
          {t(
            "Entered template name is short it should be more than 2 characters",
          )}
        </div>,
      );
    }
  };
  const handleChangeInfoData = (e) => {
    const { name, value } = e.target;
    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateNameInput") {
      if (e.target.value.length > 255) {
        toast.error(
          <div className="notificationText">
            {t(
              "Entered template name is too lengthy it should be less than 255 characters",
            )}
          </div>,
        );
      }
    }
    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
    let obj = { ...appData?.genericInfo, [name]: value };
    appData.updateGenericInfo(obj);
    setErrorMsg(false);
    setHelperText("");
  };

  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      setGenericInfo({ ...genericInfo, market: market.name });
      appData.setMarketCode(market.code);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        market: market.name,
      });
    }
  };

  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };

  const getBrandsToPopulate = () => {
    if (!brandsAndCampaigns || brandsAndCampaigns.length <= 0) {
      return [];
    }
    return brandsAndCampaigns;
  };
  //Returns Campaign list to populate in Drop down

  const handleChange = (e) => {
    const { name, value } = e.target;

    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateNameInput") {
      if (e.target.value.length > 500) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>,
        );
      }
    }

    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
  };

  const [cloneloader, setCloneloader] = useState(false);
  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save

        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        }
      }
    });
  };
  const cloneTemplateData = () => {
    if (!nameValidation(genericInfo.templateNameInput, "Template")) return;
    setCloneloader(true);
    const formData = new FormData();
    formData.append("brandName", genericInfo?.brand || "");
    formData.append("name", genericInfo?.templateNameInput);
    // formData.append("campaign", genericInfo?.campaign);
    const match = genericInfo.templateSize.match(/\d{2,4}x\d{2,4}/);
    var templateSizeRes = match[0].split("x");
    formData.append(
      "width",
      parseInt(templateSizeRes[0]) || parseInt(genericInfo.Width),
    );
    formData.append(
      "height",
      parseInt(templateSizeRes[1]) || parseInt(genericInfo.Height),
    );
    formData.append("brandId", appData?.brandId);
    formData.append("marketCode", appData?.marketCode);
    formData.append("attributes", JSON.stringify(attributes));
    formData.append("marketName", appData?.genericInfo?.market);

    cloneBanner(
      appData.assetInfo.assetId,
      formData,
      (response, err, errorCode, errorMessage) => {
        if (err) {
          const errComponent = ErrComponentToRender(errorCode);
          if (err.response.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
            toast.error(
              <div className="notificationText">
                {t(
                  "Template Name exists. Please enter a different template name",
                )}
              </div>,
            );
          } else {
            toast.error(
              <div className="notificationText">{t("apiErrors.err500")}</div>,
            );
          }
          setCloneloader(false);
        } else {
          const obj = {
            brand: response.data.brandName,
            campaign: response.data.campaign,
            market: response.data.marketName,
            templateNameInput: response.data.assetName,
          };
          appData.updateGenericInfo({ ...appData?.genericInfo, ...obj });
          setSelectedMarket(obj.market);
          appData.setAssetInfo({
            assetId: "",
            assetName: obj.templateNameInput,
          });

          localStorage.removeItem("assetId");
          localStorage.setItem("assetId", response.data.id);
          history.push(`/banner-editor/${response?.data?.id}`);

          setCloneloader(false);
        }
        setCloneloader(false);
      },
    );
  };

  const getSelectedMarket = () => {
    if (!selectedMarket && appData && appData?.genericInfo?.market) {
      const countryName = appData?.genericInfo?.market;
      const countryCode = appData.marketCode;
      const displayName = `${countryName}`;
      return { name: countryName, code: countryCode, displayName: displayName };
    }
    return selectedMarket;
  };
  React.useEffect(() => {
    if (!genericInfo?.brand) return;
    setGenericInfo({
      ...genericInfo,
      campaign: genericInfo?.brand === "— Not Brand Specific —" ? "-" : "",
    });
  }, [appData?.genericInfo.brand]);

  const handleChangeSizes = (e, id) => {
    let name = e.target.name;
    let value = e.target.value;
    setGenericInfo({
      ...genericInfo,
      templateSizeType: value,
      templateSize: "",
      Width: 0,
      Height: 0,
    });
  };

  useEffect(() => {
    setAttributes({
      ...attributes,
      customTemp: genericInfo?.templateSizeType === "Custom" ? true : false,
    });
  }, [genericInfo.templateSizeType]);

  function getTemplateSize(height, width) {
    for (let i = 0; i < templateSizes.length; i++) {
      const [name, size] = templateSizes[i].split(" ");
      const [templateWidth, templateHeight] = size.split("x").map(Number);

      if (templateWidth === width && templateHeight === height) {
        return templateSizes[i];
      }
    }

    return `${height}x${width}`;
  }

  return (
    <>
      <Dialog
        open={showCloneTemplate}
        onClose={closeCloneTempModal}
        className="newTemplateModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        {cloneloader && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress
              size="30px"
              className="customLoadermodules"
            />{" "}
          </>
        )}

        <div className="row newBnrModal">
          <div
            className="baseOnModalHeading col-md-5 createbannerhead"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
          >
            <p>{t("METADATA INFORMATION")}</p>
            <div className="details">
              <p className="sourcetag">Source</p>
              <p className="tagDescription">PromoMats</p>
              <hr className="custom-hr" />
            </div>
            <div className="details createdBtagy">
              <p className="sourcetag">Created by</p>
              <p className="tagDescription">-</p>
            </div>
            <div className="details">
              <p className="sourcetag">Created on</p>
              <p className="tagDescription">-</p>
            </div>
          </div>

          <div className="col-md-7 selectBrands customScrollBar">
            <TextField
              id="standard-basic"
              variant="standard"
              label={t("Template Name")}
              name="templateNameInput"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges bnrtxtField"
              fullWidth={true}
              value={genericInfo.templateNameInput}
              onChange={handleChange}
              onBlur={(e) => handleChangeInfoDataBlur(e)}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ color: "gray", fontSize: "12px" }}
                  >
                    {genericInfo.templateNameInput?.length > 0 &&
                      `${genericInfo.templateNameInput?.length}/500 chars`}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              variant="standard"
              label={
                <>
                  {t("PromoMats Template Doc ID")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              value={genericInfo?.promomatTempDocId}
              name="promomatTempDocid"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges disablPromo iconinfo"
              fullWidth={true}
              onChange={handleChange}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={infoIcon} className="" />
                  </InputAdornment>
                ),
              }}
              disabled={true}
            ></TextField>
            {appData?.genericInfo?.brand === "— Not Brand Specific —" ? (
              <div className="newInputFieldTemp brandNm" ref={dropdownWidth}>
                <DropDownWithLabelTemplate
                  options={{
                    value: genericInfo?.brand,
                    name: "brand",
                    label: t("bannerManager.brandName"),
                    items: getBrandsToPopulate(),
                    handleChange: handleChange,
                  }}
                  menuWidth={
                    dropdownWidth.current?.getBoundingClientRect().width *
                      0.95 || undefined
                  }
                />
              </div>
            ) : (
              <TextField
                variant="standard"
                value={genericInfo?.brand}
                name="brand"
                label={"Product"}
                className="bannerNameTextfield  templateNameTextfield ChangleCloneTextField"
                fullWidth={true}
                onChange={handleChangeInfoData}
                autoComplete="off"
                disabled="true"
              ></TextField>
            )}
            <DropDownWithSearchTemplate
              options={{
                value: getSelectedMarket(),
                name: "market",
                label: "Country",
                items: marketDataSource,
                handleChange: handleMarketChange,
              }}
              className="custonScrollBar"
            />
            <TextField
              id="standard-basic"
              variant="standard"
              label={t("Template Type")}
              name="templateType"
              className="bannerNameTextfield templateNameTextfield ChangleCloneTextField"
              fullWidth={true}
              value={genericInfoNew.isAnimated === true ? "Animated" : "Static"}
              autoComplete="off"
              disabled="true"
            />
            <div
              className="newInputFieldTemp newInputFieldTempChanges"
              style={{ marginTop: "0px" }}
            >
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo?.templateSizeType || "",
                  name: "templateSizeType",
                  label: (
                    <>
                      {t("Template Size")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: templateSizeOptions,
                  handleChange: handleChangeSizes,
                  className: "testBannersize",
                }}
              />
            </div>
            {genericInfo?.templateSizeType === "Pre-defined" && (
              <div
                className={
                  genericInfo.templateSizeType === "Pre-defined"
                    ? "newSizeInputFieldTemp chooseSize newInputFieldTemp newSizeInputFieldTempWidth"
                    : "newSizeInputFieldTemp chooseSize2 newInputFieldTemp newSizeInputFieldTempWidth"
                }
              >
                <DropDownWithLabelSizeTemplate
                  options={{
                    value: genericInfo.templateSize || "",
                    name: "templateSize",
                    label: (
                      <>
                        {t("Choose Size")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ),
                    items: templateSizes,
                    handleChange: handleChange,
                    className: "testBannersize",
                  }}
                />
              </div>
            )}
            {genericInfo?.templateSizeType === "Custom" && (
              <TextFieldInputTemp
                assetType={"template"}
                custom={true}
                setCustomSize={true}
                genericInfo={genericInfo}
                setGenericInfo={setGenericInfo}
                handleChange={handleChange}
                styleClass="hWTemplate2"
              />
            )}
          </div>
        </div>
        <DialogActions className="modalActions templateBtn">
          <Button
            onClick={() => {
              closeCloneTempModal();
              handleFormReset();
            }}
            color="primary"
            className="cancelBtntemp"
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            onClick={cloneTemplateData}
            type="submit"
            className="temp-btn"
            style={{ fontFamily: "Nunito Sans" }}
            disabled={!validateForm()}
            autoFocus
          >
            {t("bannerManager.cloneTemplate")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
